export const redirectToUrl = (url) => {
  window.location.href = url;
};
